const routes = {
  path: '/customer',
  component: () => import('@/components/layout/index.vue'),
  alwaysShow: true,
  meta: {
    title: '客户管理',
    icon: 'iconziyuan',
    permission: 'customer',
    orPermission: 'agentState' // 与permission二选一的权限(需在菜单里面自定义)
  },
  children: [
    {
      path: 'enterprice/clew/list',
      name: 'CustomeEnterPriceClew',
      component: () => import('@/views/custome/enterpriceClew/index.vue'),
      meta: {
        title: '企微线索',
        permission: 'customer.wework'
      }
    },
    {
      path: 'visitor/list',
      name: 'visitorList',
      component: () => import('@/views/custome/visitor/list'),
      meta: {
        title: '云门店访客' // 不区分权限
      }
    },
    {
      path: 'housecard/list',
      name: 'HouseCard',
      component: () => import('@/views/custome/houseCard/index'),
      meta: {
        title: '云来客' // 不区分权限
      }
    },
    {
      path: 'newyorker/list',
      name: 'NewYorker',
      component: () => import('@/views/custome/newyorker/index'),
      meta: {
        title: '新客池',
        permission: 'customer.new'
      }
    },
    {
      path: 'yun-visitor/list',
      name: 'YunVisitor',
      component: () => import('@/views/custome/yunVisitor/index'),
      meta: {
        title: '抖音访客',
      }
    },
    {
      path: 'all-custome/list',
      name: 'CustomePoolList',
      component: () => import('@/views/custome/customeManager/index.vue'),
      meta: {
        title: '客户管理',
        permission: 'customer.my.list'
      }
    },
    {
      path: 'public-pool/list',
      name: 'PublicPool',
      component: () => import('@/views/custome/publicPool/index.vue'),
      meta: {
        title: '公客池',
        permission: 'customer.public'
      }
    },
    {
      path: 'invalid-pool/list',
      name: 'InvalidPool',
      component: () => import('@/views/custome/invalidPool/index.vue'),
      meta: {
        title: '无效池',
        permission: 'customer.invalid'
      }
    },
    {
      path: 'black-list/list',
      name: 'BlackList',
      component: () => import('@/views/custome/blackPool/index.vue'),
      meta: {
        title: '黑名单',
        permission: 'customer.black'
      }
    },
    {
      path: 'import/batch/list',
      name: 'FirmMemberBatch',
      component: () => import('@/views/guideInto/index.vue'),
      meta: {
        title: '批量导入',
      },
      hidden: true
    },
    {
      path: 'custome-import/batch',
      name: 'FirmMemberBatch',
      component: () => import('@/views/guideInto/customeImport.vue'),
      meta: {
        title: '客户批量导入',
      },
      hidden: true
    },
  ]
}
export default routes;